
import React from 'react'
import { bool, object } from 'prop-types'
import Button from '../ui/button/Button'
import Icon from '../ui/icon/Icon'

/**
 * Component to display a filter that only needs one button, and the functionality comes in onClick prop
 *
 * @component
 * @example
 * return (
 *   <ButtonFilter active={true} label='Dummy Filter' onClick={() => {}} />
 * )
 */
const ButtonFilter = ({ active, label, ...rest }) => (
  <Button active={active} customClasses='button-filter' {...rest}>
    <span>{label}</span>
    {active && <Icon svg='cancelCircle' withoutFill />}
  </Button>
)

ButtonFilter.propTypes = {
  /**
   * Filter's status
   */
  active: bool,
  /**
   * Label's button
   */
  label: object
}

export default ButtonFilter